module.exports = __webpack_public_path__ + "img/incentive_img02.eb454498.jpg";